import { Box, IconButton, Typography, TablePagination } from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import React from 'react'

interface IPaginationProps {
  itemCount: number
  page: number
  pageStart: number
  pageEnd: number
  custom: boolean
  handlePagePrev: any
  handlePageNext: any
  setPage: (page: number) => void
}

export default function Pagination (props: IPaginationProps): JSX.Element {
  const handlePaging = (parentHandler: () => void): void => {
    window.scrollTo(0, 0)
    parentHandler()
  }

  const handleChange = (_event: any, value: number): void => {
    props.setPage(value + 1)
    window.scrollTo(0, 0)
  }

  const renderExperimentalPaginator = (): JSX.Element => {
    return (
      <TablePagination
        component='div'
        count={props.itemCount}
        page={props.page - 1}
        onPageChange={handleChange}
        rowsPerPage={20}
        rowsPerPageOptions={[20]}
      />
    )
  }

  const renderPageRange = (): JSX.Element => {
    const pageEnd = Math.min(props.itemCount, props.pageEnd)

    let pageRangeStr = `${props.pageStart} - ${pageEnd}`
    if (props.pageStart === props.pageEnd) pageRangeStr = props.pageStart.toString()

    return (<Typography variant='subtitle2'>{pageRangeStr}</Typography>)
  }

  const renderPaginator = (): JSX.Element => {
    const prevDisabled = (props.pageStart === 1)
    const nextDisabled = (props.pageEnd >= props.itemCount)

    return (
      <div className='c-pagination'>
        <IconButton
          data-testid='paginate__left-button'
          disabled={prevDisabled}
          onClick={() => { handlePaging(props.handlePagePrev) }}
        >
          <ChevronLeft />
        </IconButton>

        <Box sx={{ display: 'inline-flex', alignItems: 'center', ml: 1, mr: 1 }}>
          {renderPageRange()}
          <Typography variant='subtitle2' component='span' fontWeight={300} pl={1} pr={1}> of </Typography>
          <Typography variant='subtitle2'>{props.itemCount}</Typography>
        </Box>

        <IconButton
          data-testid='paginate__right-button'
          disabled={nextDisabled}
          onClick={() => { handlePaging(props.handlePageNext) }}
        >
          <ChevronRight />
        </IconButton>
      </div>
    )
  }

  return props.custom ? renderExperimentalPaginator() : renderPaginator()
}
